module.exports = __webpack_public_path__ + "img/kommune-1103.d47ccb11.svg";